import type { PluginRegistry } from '@common/plugin-host'
import mediaImageManifest from '@common/plugin-media-image/manifest'
import MediaImage from '@common/plugin-media-image/ui'
import mediaVideoManifest from '@common/plugin-media-video/manifest'
import MediaVideo from '@common/plugin-media-video/ui'
import mediaAudioManifest from '@common/plugin-media-audio/manifest'
import MediaAudio from '@common/plugin-media-audio/ui'
import mediaTextManifest from '@common/plugin-media-text/manifest'
import MediaText from '@common/plugin-media-text/ui'
import mediaBinaryManifest from '@common/plugin-media-binary/manifest'
import MediaBinary from '@common/plugin-media-binary/ui'
import spLessonManifest from '@common/plugin-sp-lesson/manifest'
import SpLesson from '@common/plugin-sp-lesson/ui'
import spSequenceManifest from '@common/plugin-sp-sequence/manifest'
import SpSequence from '@common/plugin-sp-sequence/ui'

const plugins = [
  { ...mediaImageManifest, component: MediaImage },
  { ...mediaVideoManifest, component: MediaVideo },
  { ...mediaAudioManifest, component: MediaAudio },
  { ...mediaTextManifest, component: MediaText },
  { ...spLessonManifest, component: SpLesson },
  { ...spSequenceManifest, component: SpSequence },
  { ...mediaBinaryManifest, component: MediaBinary },
]

export const assetPluginRegistry: PluginRegistry = Object.fromEntries(plugins.map((plugin) => [plugin.id, plugin]))
